import { Auth } from 'aws-amplify';

export async function signOutAPI() {
  return Auth.signOut();
}
